// Traduction / langues des chaînes JS.
// console.log( $('#appLanguage').text() );

$.i18n.properties({
	name: 'Messages',
	language: $('#appLanguage').html(),
	path: '/js/i18n/',
	mode: 'map',
	cache: false,
});